import { Observable } from 'rxjs';
import {
  OrdersSearchResaltTableColumnViewModel,
  OrdersSearchResaltViewTemplateModel,
} from 'src/app/store/orders-search-resalt-view-template/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractOrdersSearchResaltViewTemplateApiService {
  public abstract getViewForUser(userId: number): Observable<InteractorResponse<OrdersSearchResaltViewTemplateModel>>;
  public abstract setViewForUser(
    userId: number,
    viewTemplate: OrdersSearchResaltTableColumnViewModel[]
  ): Observable<InteractorResponse<OrdersSearchResaltViewTemplateModel>>;
}
